import { useSelector } from 'react-redux';
import { useAuthBackground } from '../../hooks/useAuthBackground';
import Link from 'components/ui/link';
import PrivacyLinks from 'pages/app/components/policyLinks';
import { RootState } from 'store';
import './pageAuth.scss';

export const PageAuthWrapper: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const backgroundImage = useAuthBackground();

  const {
    brandConfig: {
      config: {
        assets: { logoLightUrl },
      },
    },
    visibleLegalLink,
  } = useSelector((state: RootState) => state.settings);

  return (
    <div className='page-auth-new'>
      <div
        className='page-auth-new__banner'
        style={{
          backgroundImage,
        }}
      />
      <div className='page-auth-new__container'>
        <div className='page-auth-new__content'>
          {logoLightUrl ? (
            <div className='page-auth-new__logo'>
              <Link url='/login'>
                <img
                  src={logoLightUrl}
                  alt='logo'
                  className='page-auth-new__logo-pic'
                />
              </Link>
            </div>
          ) : null}
          <div className='page-auth-new__form'>{children}</div>
        </div>
      </div>
      {visibleLegalLink ? (
        <div className='page-auth-new__footer'>
          <PrivacyLinks />
        </div>
      ) : null}
    </div>
  );
};
